// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const modalStyles = css`
  .TCPModal__InnerContent.filter-innerContent {
    right: 0;
    left: auto;
    top: 0;
    bottom: 0;
    transform: none;
    box-shadow: 0 4px 8px 0 rgba(163, 162, 162, 0.5);
    padding: 0px;
    width: 350px;
    overflow-x: hidden;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 375px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: 481px;
      animation: slide-in 0.5s forwards;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: flex;
      flex-direction: column;
      width: 100%;
      animation: slide-in-mobile 0.5s forwards;
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS}
        ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0px 0px;
      padding: 0px 0 20px 0px;
      ${(props) => (props.isHPLP ? 'padding: 0px 0px 30px 0px' : '')};
      top: auto;
      bottom: 0;
      height: 60%;
    }
    @keyframes slide-in {
      0% {
        transform: translateX(100%);
      }
      100% {
        transform: translateX(0%);
      }
    }
    @keyframes slide-in-mobile {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(5%);
      }
    }
    @keyframes slide-out {
      0% {
        transform: translateX(0%);
      }
      100% {
        transform: translateX(100%);
      }
    }
  }
  .TCPModal__InnerContent::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
  .filter-redesign::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  .close-modal {
    top: 4px;
    height: 20px;
    width: 20px;
    right: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    padding-top: 40px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (props.isHPLP ? 'top:12px;right:18px;' : '')}
    }
  }
  .blurred-content {
    filter: blur(4px);
    -o-filter: blur(4px);
    -ms-filter: blur(4px);
    -moz-filter: blur(4px);
    -webkit-filter: blur(4px);
  }
  .Modal-Header {
    top: 0;
    position: sticky;
    min-height: 54px;
    z-index: ${(props) => props.theme.zindex.zIndexQuickView};
  }
  .modal-heading {
    border-bottom: none;
    padding-bottom: 26px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    justify-content: center;
    height: auto;
    display: block;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 30px 0 20px;
    white-space: nowrap;
    @media ${(props) => props.theme.mediaQuery.medium} {
      justify-content: center;
      height: auto;
      padding-top: 5px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      padding-top: 9px;
      text-align: center;
    }
  }
  .Modal_Heading {
    border-bottom: none;
    padding: 19px;
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    justify-content: center;
    height: auto;
    margin-bottom: 0px;
    background-color: #f4f4f4;
    text-transform: lowercase;
    text-align: center;
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: auto;
      display: inline-block;
      width: 100%;
      text-align: left;
      padding-left: 24px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      background-color: ${(props) => (props.isHPLP ? `${props.theme.colors.WHITE}` : '#f4f4f4')};
      ${(props) => (props.isHPLP ? 'font-size:21px;line-height:28px;padding:24px 18px;' : '')}
    }
  }
  .Modal_Heading:first-letter {
    text-transform: uppercase;
  }

  .sort-options-container {
    padding: 15px 28px 0px 28px;
    overflow-y: auto;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 15px 24px 0px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: calc(100% - 140px);
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (props.isHPLP ? 'padding:0 18px;' : '')}
    }
  }
  .sort-options-container::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  .sort-options-container .sidebar {
    display: none;
  }

  .sort-selected {
    background-color: #f1f5f7;
    padding: 20px 0px 16px;
    border-radius: 16px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      border-radius: 6px;
    }
  }
  .sortOptionId {
    height: 54px;
  }
  .sort-option-title {
    padding: 20px 0px 16px;
  }
  .radio-button {
    top: 17px !important;
  }
  .radio-button-checked {
    top: 17px !important;
  }
  .input-radio-title {
    margin-top: -5px;
    display: flex;
    margin-left: 40px;
  }
  .radio-button-checked + .input-radio-title {
    font-weight: 800;
  }
  .see-results-container {
    bottom: 0;
    background-color: ${(props) => props.theme.colors.WHITE};
    padding: 12px 32px;
    border-top: 1px solid #e3e3e3;
    display: flex;
    z-index: 10;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      bottom: 20px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) => (props.isHPLP ? 'position: absolute' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: ${(props) => (props.isHPLP ? '16px 18px' : '12px 32px')};
      ${(props) => (props.isHPLP ? 'gap: 10px' : '')};
      ${(props) => (props.isHPLP ? 'justify-content: center' : '')};
    }
  }

  .sort-cnt {
    height: 59px;
    width: 85%;
    position: absolute;
  }

  .filter-cnt {
    width: 90%;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      bottom: 40px;
      z-index: 5;
    }
  }
  .clear-button {
    background: #ffffff;
    border: 1px solid #000000;
    box-sizing: border-box;
    width: 162px;
    margin: auto;
    margin-right: 20px;
    height: 46px;

    @media ${(props) => props.theme.mediaQuery.large} {
      width: ${(props) => (props.isHPLP ? '166px' : '162px')};
      ${(props) => (props.isHPLP ? 'margin: 0' : 'margin: auto')};
      ${(props) => (props.isHPLP ? 'margin-right: 0' : 'margin-right: 20px')};
      ${(props) => (props.isHPLP ? 'border-radius: 6px' : '')};
    }
  }
  .clear-button:focus {
    background: none;
  }
  .see-results-button {
    display: flex;
    width: 100%;
    background-color: ${(props) => props.theme.colorPalette.blue.C900};
    color: ${(props) => props.theme.colors.WHITE};
    margin: auto;
    justify-content: center;
    height: 46px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 15px 21px;
      margin-right: 25px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      align-items: center;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (props.isHPLP ? 'border-radius: 6px' : '')};
      ${(props) => (props.isHPLP ? 'margin: 0' : 'margin: auto')};
      width: ${(props) => (props.isHPLP ? '166px' : '100%')};
    }
  }
  .sort-cnt .see-results-button {
    margin-right: 0px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .filterFormHeight {
      height: fit-content !important;
    }
  }
`;

export const productInfoStyles = css`
  margin-bottom: 10px;
  .product {
    margin: 0;
    width: 100%;
  }
`;
